module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0028.png.9bd69c0b.jpg";